import Vue from 'vue'
import { capitalize } from 'lodash'

Vue.filter('capitalize', (str) => capitalize(str))